import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MessageBoxContainer, MessageBoxContent, MessageBoxDescription, MessageBoxTitle } from './subcomponents';
const SIAutopayMessageBox = ({ autopayStartDate }) => {
    return (_jsx(MessageBoxContainer, Object.assign({ "data-cy": "autopay-si-message-box", icon: _jsx(FontAwesomeIcon, { icon: faInfoCircle }), type: "info" }, { children: _jsxs(MessageBoxContent, { children: [_jsx(MessageBoxTitle, { children: _jsx(Trans, { i18nKey: "autopaySIMessageBox.title", values: {
                            autopayStartDate
                        } }) }), _jsx(MessageBoxDescription, { children: _jsx(Trans, { i18nKey: "autopaySIMessageBox.description" }) })] }) })));
};
export default SIAutopayMessageBox;
